export default "__VITE_ASSET__6f649e37__"